const guards = {
  employmentExists: ({employments}, {data: employmentId}) => employments.some((item) => item.id === employmentId),
  idleState: (_, __, {state}) => state.value === "idle",
  hasEmploymentUpdateEvents: ({unprocessedEvents}) =>
    unprocessedEvents.some((item) => item.type === "employmentUpdated"),
  employmentsNotLoaded: ({employmentActions}) => !employmentActions,
};

export default guards;
